import React from 'react'

import {Grid} from '../grid'
import {classes} from './UnstableCardHeader.classes'

type Props = {
  primary: React.ReactNode
  secondary?: React.ReactNode
}

export const UnstableCardHeader: React.FC<Props> = ({primary, secondary}) => {
  return (
    <div className={classes.root}>
      <Grid spacing={1} wrap="nowrap" container>
        <Grid item xs>
          {primary}
        </Grid>
        {secondary && <Grid item>{secondary}</Grid>}
      </Grid>
    </div>
  )
}
